import React from 'react'
import { useStyles } from './styles'
import { PageTitle as SectionTitle } from 'src/components/PageTitle'
import { formatDate } from 'src/utils'
import { CustomTable, Loading } from 'src/components'
import { useGetVaccineHistoryList } from 'src/hooks/api/animal'
import { IAnimal } from 'src/dto/animal.dto'

interface IHealthControl {
  data?: IAnimal
}

export const HealthControl: React.FC<IHealthControl> = ({ data }) => {
  const { data: vaccineHistoryList, isLoading } = useGetVaccineHistoryList(data?.idAnimal!)

  const styles = useStyles()

  const tableHeader = [
    {
      property: 'tipo',
      name: 'VACINA',
      textAlign: 'center',
      format: (value: string | null) => (value ? value : '-')
    },
    {
      property: 'dose',
      name: 'DOSAGEM',
      format: (value: string | null) => (value ? value : '-'),
      textAlign: 'center'
    },

    {
      property: 'status',
      name: 'STATUS',
      textAlign: 'center',
      format: (value: string | null) => (value ? value : '-')
    },
    {
      property: 'dataAplicacao',
      name: 'DATA',
      textAlign: 'center',
      format: (value: string) => (value ? formatDate(value) : '-')
    }
  ]

  if (isLoading) {
    return (
      <section>
        <h1 className={styles.healthControlTitle}>{data?.nome || ''}</h1>
        <div className={styles.healthControlContent}>
          <SectionTitle className={styles.sectionName}>Vacina</SectionTitle>
          <Loading />
        </div>
      </section>
    )
  }

  return (
    <section>
      <h1 className={styles.healthControlTitle}>{data?.nome || ''}</h1>
      <div className={styles.healthControlContent}>
        <SectionTitle className={styles.sectionName}>Vacina</SectionTitle>
        <CustomTable header={tableHeader} body={vaccineHistoryList!} itemsPerPage={4} />
      </div>

      {/* <div className={styles.healthControlContent}>
        <SectionTitle className={styles.sectionName}>Vacina</SectionTitle>
        <CustomTable header={tableHeader} body={list} itemsPerPage={4} />
      </div> */}
    </section>
  )
}
